export default class FAQ {
    constructor(element) {
        this.element = element;
        this.titre = element.querySelectorAll('.question__titre');
        this.reponse = element.querySelector('.question__reponse');

        this.init();
    }

    init(){
        for (let i = 0; i < this.titre.length; i++) {
            const question = this.titre[i];
            question.addEventListener('click', this.toggle.bind(this));
            
        }
    }

    toggle() {
        this.element.classList.toggle('is-open');
    }
}